import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-critical-error',
  imports: [],
  templateUrl: './critical-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './critical-error.component.scss'
})
export class CriticalErrorComponent {

}
